import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CHAT_GPT, XANO } from 'drapcode-constant';
import * as actions from '../../features/external-api/redux/actions';
import ExternalApiHeaderNav from './ExternalApiHeaderNav';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ExternalApiList from './ExternalApiList';
import { checkExternalAPIPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';

export class Xano extends Component {
  static propTypes = {
    externalApi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { page: 0, searchTerm: '', limit: 25, headers: [] };
  componentDidMount = async () => {
    const { match, actions, home } = this.props;
    const { projectId, version } = match.params;
    await actions.loadCollections({ projectId, version });
    await actions.loadExternalApis({
      projectId,
      page: this.state.page,
      externalApiType: XANO,
      limit: this.state.limit,
      version,
    });
    const externalapi = await actions.loadExternalDatabase({ projectId, version });
    if (externalapi) {
      const dataTypes = [...new Set(externalapi.map((item) => item.type))];
      this.setState({ headers: dataTypes });
    }
  };
  render() {
    const isAllowed = checkExternalAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Xano" />;
    }
    const { match, home } = this.props;
    const { iPlugins } = home;
    const chatGptPlugin = iPlugins && iPlugins.find((e) => e.code === CHAT_GPT);
    const { projectId, version } = match.params;
    const { headers } = this.state;
    return (
      <CommonPageComponent>
        <ExternalApiHeaderNav
          activeTab={XANO}
          projectId={projectId}
          headers={headers}
          version={version}
          enableChatGpt={chatGptPlugin ? true : false}
        />
        <ExternalApiList projectId={projectId} activeTab={XANO} version={version} />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalApi: state.externalApi,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Xano);
